module.exports = __webpack_public_path__ + "static/ru-1-e798a00f2fec1ffe7fc02f2fcc8ce52d.png";